import { render, staticRenderFns } from "./xsbadnessReportAction.vue?vue&type=template&id=a0e07f52&scoped=true"
import script from "./xsbadnessReportAction.vue?vue&type=script&lang=js"
export * from "./xsbadnessReportAction.vue?vue&type=script&lang=js"
import style0 from "./xsbadnessReportAction.vue?vue&type=style&index=0&id=a0e07f52&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e07f52",
  null
  
)

export default component.exports